import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { ensureSession } from '@/auth/auth-store';

/**
 * Toutes les routes applicatives vivent sous /$tenant/… : le tenant est dans l'URL, et c'est lui
 * qui choisit le realm Keycloak (un realm par tenant) puis l'en-tête X-Tenant du mutator.
 *
 * `beforeLoad` s'exécute avant tout rendu : il résout tenant → realm (lookup public, mis en
 * cache) et restaure la session. Pas de session → /login, en gardant la cible pour y revenir.
 */
export const Route = createFileRoute('/$tenant')({
  beforeLoad: async ({ params, location }) => {
    const session = await ensureSession(params.tenant);
    if (!session) {
      throw redirect({
        to: '/login',
        search: { tenant: params.tenant, returnTo: location.pathname },
        replace: true,
      });
    }
    return { session };
  },
  component: () => <Outlet />,
});
